export default __webpack_public_path__ + "media/zurb/img/ecommerce/tmw_comp_2-15074b48dd5b90878691a17dd9898ca8.png";